import { useCallback } from 'react';
import { useFilter } from '@spa/features/search_job/pc/contexts/FilterContext';
import { useTrack } from "@spa/features/search_job/pc/contexts/TrackContext";
import { useLocation } from "react-router-dom";
import { SalaryConstants } from '@src/common/service/salary/salaryHelper';

/**
 * 給与フィルターの初期化処理を担当するカスタムフック
 * 
 * @param {Object} params - パラメータ
 * @param {string} params.salaryTypeParamKey - 給与種別パラメータキー
 * @param {string} params.salaryMinParamKey - 給与最小値パラメータキー
 * @param {string} params.salaryMaxParamKey - 給与最大値パラメータキー
 * @returns {Object} 初期化処理の結果
 */
const useSalaryFilterInitializer = ({
    salaryTypeParamKey,
    salaryMinParamKey,
    salaryMaxParamKey,
}) => {
    // === 外部フックの初期化 ===
    const { getFilterValue } = useFilter();
    const { channelName } = useTrack();
    const location = useLocation();

    /**
     * 初期値をrefで保持するためのオブジェクトを生成
     * @returns {Object} 初期値オブジェクト
     */
    const getInitialSalaryState = useCallback(() => {
        const salaryType = getFilterValue(salaryTypeParamKey) || SalaryConstants.ALL_TYPE_ID;
        const salaryMin = getFilterValue(salaryMinParamKey);
        const salaryMax = getFilterValue(salaryMaxParamKey);
        
        return {
            salaryType: salaryType,
            salaryMin: salaryMin || '',
            salaryMax: salaryMax || ''
        };
    }, [getFilterValue, salaryTypeParamKey, salaryMinParamKey, salaryMaxParamKey]);

    return {
        // 外部フック
        channelName,
        location,
        
        // 初期化関数
        getInitialSalaryState,
    };
};

export default useSalaryFilterInitializer; 